import { twMerge } from 'tailwind-merge';
import {
  DialogTitle,
  DialogActions,
  DialogContent,
  Dialog as MuiDialog,
} from '@mui/material';

import { Button } from '../button';

import { DialogProps } from './types';

export const Dialog = ({
  open,
  title,
  onClose,
  actions,
  children,
  className,
  maxWidth = 'sm',
  contentClassName,
}: DialogProps) => {
  return (
    <MuiDialog
      fullWidth
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      slotProps={{
        paper: {
          className: twMerge('mx-4 w-full rounded-2xl', className),
        },
      }}
    >
      {title ? (
        <DialogTitle className="px-6 pt-6 pb-2 text-xl font-semibold">
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent className={twMerge('px-6 pb-2', contentClassName)}>
        {children}
      </DialogContent>
      <DialogActions className="px-6 pt-2 pb-6">
        {actions ?? (
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
        )}
      </DialogActions>
    </MuiDialog>
  );
};

export type { DialogProps };
